var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"funcionalidade-customizada-detalhe"}},[_c('funcionalidade-header',{attrs:{"titulo":_vm.tituloNavegacao}}),_c('solicitacao-detalhe')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }